import { useEffect, useState } from 'react';
import { quests } from '../services/api/models.ts'; // Adjust the import path if needed
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthHelper } from './useAuthHelper';

const useGetRegistrationsAPI = (questId, queryFilters) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const { getSafeAccessToken } = useAuthHelper();

  useEffect(() => {
    async function getData() {
      try {
        if (!isAuthenticated) {
          await loginWithRedirect();
        }

        const accessToken = await getSafeAccessToken();
        
        // If token is null, redirect is happening
        if (!accessToken) {
          return;
        }

        const headers = { Authorization: `Bearer ${accessToken}` };
        const options = { headers };
        const limit = 1000, skip = 0, filter = {};
        if (queryFilters) {
          filter['userId'] = queryFilters.userId;
        }
        const response = await quests.questsQuestIdEnlistGet(questId, limit, skip, filter, options);
        console.log("get registrations :::::::::::::", response.data.data);
        setData(response.data.data || []);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }

    getData();
  }, [questId]);

  return { isLoading, data, error };
};

export default useGetRegistrationsAPI;
